import groq from 'groq';

import { CONSENT_CAPTURE, OVERLINE } from '../common';
import { BANNER_MEDIA } from './banner';

export const SIGNUP_BANNER = groq`
  ${OVERLINE},
  title,
  subtitle,
  ctaTitle,
  klaviyoListId,
  ${CONSENT_CAPTURE},
  media[0] {
    ${BANNER_MEDIA}
  },
  isForceWhiteText
`;

export const SIGNUP_BANNER_BLOCK = groq`
  _type == 'timeline_signupBanner' => {
    ${SIGNUP_BANNER}
  }
`;
